import React, { useState, useEffect } from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authApi } from '../api/auth';
import { AuthLayout } from '../components/Layout/AuthLayout';
import { Input } from '../components/common/Input';
import { Button } from '../components/common/Button';
import './Auth.css';

const ResetPassword = () => {
  usePageTitle('Nova senha');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setErrorMessage('Link de recuperação inválido ou ausente.');
    }
  }, [token]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token) return;

    if (password !== confirmPassword) {
      setStatus('error');
      setErrorMessage('As senhas não coincidem.');
      return;
    }

    if (password.length < 8) {
      setStatus('error');
      setErrorMessage('A senha deve ter pelo menos 8 caracteres.');
      return;
    }

    try {
      setStatus('loading');
      await authApi.resetPassword(token, password);
      setStatus('success');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err: any) {
      setStatus('error');
      setErrorMessage(err.message || 'Ocorreu um erro ao redefinir sua senha.');
    }
  };

  return (
    <AuthLayout currentStep={1}>
      <div className="auth-page">
        <div className="auth-header">
          <h2 className="auth-title">Nova Senha</h2>
          <p className="auth-subtitle">
            Crie uma nova senha segura para sua conta.
          </p>
        </div>

        {status === 'success' ? (
          <div style={{ textAlign: 'center', margin: 'var(--space-6) 0' }}>
            <div style={{
              backgroundColor: 'rgba(16, 185, 129, 0.1)',
              border: '1px solid rgba(16, 185, 129, 0.2)',
              color: '#10b981',
              padding: 'var(--space-4)',
              borderRadius: 'var(--radius-md)',
              marginBottom: 'var(--space-4)',
            }}>
              Senha Redefinida!
            </div>
            <p style={{ color: 'var(--color-text-secondary)', fontSize: 'var(--text-sm)', marginBottom: 'var(--space-6)' }}>
              Sua senha foi alterada com sucesso. Você será redirecionado para o login.
            </p>
            <Link to="/login">
              <Button type="button" variant="secondary" fullWidth>
                Ir para o Login Agora
              </Button>
            </Link>
          </div>
        ) : (
          <>
            {status === 'error' && (
              <div style={{
                backgroundColor: 'rgba(239, 68, 68, 0.1)',
                border: '1px solid rgba(239, 68, 68, 0.2)',
                color: '#f87171',
                padding: 'var(--space-3)',
                borderRadius: 'var(--radius-md)',
                marginBottom: 'var(--space-4)',
                fontSize: 'var(--text-sm)',
                textAlign: 'center'
              }}>
                {errorMessage}
              </div>
            )}

            <form className="auth-form" onSubmit={handleSubmit}>
              <Input 
                label="Nova Senha" 
                name="password" 
                type="password" 
                placeholder="Mínimo 8 caracteres" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required 
                disabled={status === 'loading' || !token}
              />
              
              <Input 
                label="Confirmar Nova Senha" 
                name="confirmPassword" 
                type="password" 
                placeholder="Digite a senha novamente" 
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required 
                disabled={status === 'loading' || !token}
              />

              <Button type="submit" variant="secondary" fullWidth disabled={status === 'loading' || !token}>
                {status === 'loading' ? 'Salvando...' : 'Redefinir Senha'}
              </Button>
            </form>

            <div className="auth-footer" style={{ marginTop: 'var(--space-6)' }}>
              <Link to="/login">Voltar ao login</Link>
            </div>
          </>
        )}
      </div>
    </AuthLayout>
  );
};

export default ResetPassword;
